import { Deserializable } from '../deserializable';

export class AdviceNoteDto implements Deserializable {
  public Note: string;
  public AddedByUser: string;
  public DateAdded?: Date;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
